import React, {FC, useEffect, useState} from 'react'
import {observer} from 'mobx-react'
import useStore from 'store'
import { FeatureIds } from 'utils/types'
import {useTranslation} from 'react-i18next'
import {Space} from '../../ui'
import { Switch } from '@material-ui/core'
import {
    ModalRow,
    ModalText,
    ConfirmButtonSm,
    ButtonGroup,
    DialogHeaderText,
    ToggleGroup,
    ToggleRow
} from './styles'


export interface UserManagementFormState {
    isEnable: boolean
}

interface UserManagementSectionProps {
    currentOrgId: number | undefined
    resetForm: boolean
}


const UserManagementSection: FC<UserManagementSectionProps> = ({ currentOrgId, resetForm }) => {
    const {modulesStore, orgs: orgsStore} = useStore()
    const {t} = useTranslation('communitySettings')

    const [isFormChanged, setIsFormChanged] = useState<boolean>(false)
    const [module, setModule] = useState<any>(null)
    const [formState, setFormState] = useState<UserManagementFormState>({
        isEnable: false
    })

    useEffect(() => {
        const userManagementModule = modulesStore.communityFeatures.find(el => el.featureName === 'UserManagement')
        if (userManagementModule) {
            setModule(userManagementModule)
            setFormState({ isEnable: userManagementModule.enabled })
        } else {
            orgsStore.updateCommunity(currentOrgId, [...modulesStore.communityFeatures, {
                communityId: currentOrgId,
                enabled: false,
                featureName: 'UserManagement',
                id: FeatureIds.POPULATION_MANAGEMENT,
                status: 2,
            }]).then(async () => {
                await modulesStore.getCommunityModulesAndFeatures(currentOrgId)
                const newModule = modulesStore.communityFeatures.find(el => el.featureName === 'UserManagement')
                if (newModule) {
                    setModule(newModule)
                    setFormState({ isEnable: newModule.enabled })
                }
            })
        }
    }, [currentOrgId])

    useEffect(() => {
        if (resetForm) onResetForm()
    }, [resetForm])

    useEffect(() => {
        setIsFormChanged(
            formState.isEnable !== (module?.enabled ?? false)
        )
    }, [formState, module])

    const Save = async () => {
        if (currentOrgId) {
            await orgsStore.updateCommunity(currentOrgId,
                modulesStore.communityFeatures.map(el => el.featureName === 'UserManagement' ? {
                    communityId: el.communityId,
                    enabled: formState.isEnable,
                    featureName: el.featureName,
                    id: el.id,
                    status: formState.isEnable ? 1 : 2,
                } : el),)

            await modulesStore.getCommunityModulesAndFeatures(currentOrgId)

            const userManagementModule = modulesStore.communityFeatures.find(el => el.featureName === 'UserManagement')
            if (userManagementModule) {
                setModule(userManagementModule)
                setFormState({ isEnable: userManagementModule.enabled })
            }
        }
    }

    const onResetForm = () => setFormState({
        isEnable: false
    })

    const ToggleEnable = (value: any) => setFormState({...formState, isEnable: value })

    return (
        <>
            <ModalRow>
               <DialogHeaderText>{t`populationTab`}</DialogHeaderText>
               <ButtonGroup>
                 <ConfirmButtonSm disabled={!isFormChanged || module == null} onClick={Save} transparent>{t`save`}</ConfirmButtonSm>
               </ButtonGroup>
            </ModalRow>

            {module &&
                <ToggleGroup>
                    <ToggleRow>
                        <ModalText>{t`isEnable`}:</ModalText>
                        <Switch
                            color="primary"
                            value={formState.isEnable}
                            onChange={({target}) => {
                                ToggleEnable(target.checked)
                            }}
                            checked={formState.isEnable}
                        />
                    </ToggleRow>
                </ToggleGroup>
            }
            <Space/>
            <Space/>
        </>
    )
}

export default observer(UserManagementSection)
